import { types, API_URL } from './types';
import { axiosApi } from './index';

export const getReportDashboard = (start = '', end = '') => {
  let url = `${API_URL}/api/v1/report/dashboard?start=${start}&end=${end}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .get(url)
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setGetReportDashboard(outputData));
        } else {
          outputData['status'] = 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setGetReportDashboard(outputData));
        }
      })
      .catch((error) => {
        outputData['status'] = 'danger';
        if (error.response) {
          outputData['message'] =
            error.response.data?.message || 'Error al cargar dashboard';
        } else {
          outputData['message'] = 'Error de conexión con el servidor';
        }
        dispatch(setGetReportDashboard(outputData));
      });
  };
};

export const setGetReportDashboard = (data) => ({
  type: types.rpGetDashboard,
  payload: data,
});
